import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoRangeSliderMixin from './KendoRangeSliderMixin'

export default {
    name: 'kendo-rangeslider',
    mixins: [ KendoRangeSliderMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement

        if (this.v3) {
            return h('div',[
                h('input', {
                    name: this.selectionStartName
                }),
                h('input', {
                    name: this.selectionEndName
                })
            ])
        } else {
            return h('div',[
                h('input', {
                    props: {
                        name: this.selectionStartName
                    }
                }),
                h('input', {
                    props: {
                        name: this.selectionEndName
                    }
                })
            ])
        }
    },
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoRangeSlider/index.js